import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {Moment} from "moment";
import {AvdbIssue} from "./avdb-issue";
import {AvdbRegion} from "./avdb-region";
import {Message} from "./common/message";

export class DeviceAvdbSeries extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty()
	region: AvdbRegion;

	@jsonProperty()
	supportsSYNC: boolean;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbIssue))
	installableIssues: Array<AvdbIssue>;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbIssue))
	availableIssues: Array<AvdbIssue>;

	@jsonProperty()
	issuesRemaining: number;

	@jsonProperty(JSONMapper.timestampFromISO)
	expectedEndDate: Moment;

	@jsonProperty()
	isFree: boolean;

	@jsonProperty()
	isAutoRenew: boolean;

	@jsonProperty(JSONMapper.arrayOfClass(Message))
	messages: Array<Message>;

	constructor(data?: Partial<DeviceAvdbSeries>) {
		super();
		Object.assign(this, data);
	}

	get getNextAvailableIssue() {
		if (this.installableIssues.length > 1) {
			return this.installableIssues
				.sort((issueA, issueB) => {return ((issueA.availableAt > issueB.availableAt) ? -1 : 1)})
				.filter(issue => (issue.availableAt.isBefore(Date.now())))[0];
		} else {
			return this.installableIssues[0];
		}
	}
}
